import { FILTERS_NAMES, SORT_VALUES } from '@src/constants/filters';

export enum LoanTerm {
    ANY = '',
    LESS_THAN_MONTH = 'less_month',
    LESS_THAN_TWO_MONTHS = 'less_two_months',
    MORE_THAN_TWO_MONTHS = 'more_than_two_months',
}

export enum ObtainingMethod {
    ANY = '',
    CARD_OR_ACCOUNT = 'card-or-account',
    ANY_E_WALLET = 'any-e-wallet',
    CASH = 'cash',
}

export const TERM_OPTIONS = [
    { label: 'Любой', value: LoanTerm.ANY },
    { label: 'До месяца', value: LoanTerm.LESS_THAN_MONTH },
    { label: 'До 2х месяцев', value: LoanTerm.LESS_THAN_TWO_MONTHS },
    { label: 'От 2х месяцев', value: LoanTerm.MORE_THAN_TWO_MONTHS },
];

export const OBTAINING_METHOD_OPTIONS = [
    { label: 'Любой', value: ObtainingMethod.ANY },
    { label: 'Карта или счёт', value: ObtainingMethod.CARD_OR_ACCOUNT },
    { label: 'Электронный кошелек', value: ObtainingMethod.ANY_E_WALLET },
    { label: 'Наличные', value: ObtainingMethod.CASH },
];

export const TERM_FILTER_VALUES: Record<LoanTerm, Partial<Record<FILTERS_NAMES, string | number>>> = {
    [LoanTerm.ANY]: {
        [FILTERS_NAMES.TERM_RANGE_FROM]: '',
        [FILTERS_NAMES.TERM_RANGE_TO]: '',
        [FILTERS_NAMES.SORT]: '',
    },
    [LoanTerm.LESS_THAN_MONTH]: {
        [FILTERS_NAMES.TERM_RANGE_FROM]: 0,
        [FILTERS_NAMES.TERM_RANGE_TO]: 30,
        [FILTERS_NAMES.SORT]: SORT_VALUES.TERM_ASC,
    },
    [LoanTerm.LESS_THAN_TWO_MONTHS]: {
        [FILTERS_NAMES.TERM_RANGE_FROM]: 0,
        [FILTERS_NAMES.TERM_RANGE_TO]: 60,
        [FILTERS_NAMES.SORT]: SORT_VALUES.TERM_ASC,
    },
    [LoanTerm.MORE_THAN_TWO_MONTHS]: {
        [FILTERS_NAMES.TERM_RANGE_FROM]: 61,
        [FILTERS_NAMES.TERM_RANGE_TO]: 10 ** 5,
        [FILTERS_NAMES.SORT]: SORT_VALUES.TERM_DESC,
    },
};
